import { usePlacementTestStore } from "@/stores/placementTest.store";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { TestProgressAnimation } from "../popups/test-progress-animation";

const GlobalModals = () => {
  const {
    isRunningPlacementOpen,
    setIsRunningPlacementOpen,
    selectedTestData,
    updateRunningTestData,
  } = usePlacementTestStore();

  if (!selectedTestData) {
    return null;
  }

  return (
    <Dialog
      open={isRunningPlacementOpen}
      onOpenChange={setIsRunningPlacementOpen}
    >
      <DialogContent className="max-w-[70vw] p-0">
        <TestProgressAnimation
          testId={selectedTestData?.testId}
          senderEmail={selectedTestData?.senderEmail}
          testType={selectedTestData?.testType}
          provider={selectedTestData?.provider}
          onCompleteShowReport={false}
          onComplete={(update) => {
            updateRunningTestData(selectedTestData?.testId, {
              status: update.status,
            });
            setIsRunningPlacementOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default GlobalModals;
